/**
 * Constants for identifying well-known reference frames.
 *
 * @enum {Number}
 */
var ReferenceFrame = {
  /**
   * The fixed frame.
   *
   * @type {Number}
   * @constant
   */
  FIXED: 0,

  /**
   * The inertial frame.
   *
   * @type {Number}
   * @constant
   */
  INERTIAL: 1,
};
export default Object.freeze(ReferenceFrame);
